import UserStore from '../../../../stores/UserStore';
import { createSelector } from 'reselect';
import { getRegionNameRecursively } from '../../../../helpers/common';

const regions = (state) => state.regions.list;
const goalEntries = (state) => state.goalEntries.list;

export const getHeaderNames = createSelector(
    () => {
        const offerNames = UserStore.getTranslation().offersPage;
        return [
            offerNames.goalsList.access,
            `${offerNames.goalsList.offerName}<br/> (${offerNames.goalsList.goal})`,
            offerNames.offer.conditions
        ];
    }
);

export const getRegions = createSelector(
    regions,
    (regions = []) => {
        let object = {};

        regions.map((item) => {
            object[item.id] = getRegionNameRecursively(item);
        });

        return object;
    }
);

export const getGoalEntries = createSelector(
    goalEntries,
    (goalEntries = []) => {
        return goalEntries;
    }
);
